// react-hooks-form doesn't support arrays of errors, so we join and split them with a custom divider
export const VALIDATION_DIVIDER_STRING = '___DIVIDER___';

type ValidationFunction<T = any> = (value: T, context?: Record<string, unknown>) => string | undefined;

export const composeValidations = <T = any>(...validations: ValidationFunction<T>[]) => {
  return (value: T, context?: Record<string, unknown>) => {
    let errors: string[] = [];

    for (let i = 0; i < validations.length; i++) {
      const validation = validations[i];

      const error = validation?.(value, context);
      if (!(Array.isArray(error) && error.length === 0)) {
        errors.push(error as string);
      }
    }

    return errors.join(VALIDATION_DIVIDER_STRING) || undefined;
  };
};
